import React from 'react';
import { Box, Container, Link, Stack } from '@mui/material';
import Typography from '../i18n/LocalizedTypography';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { translatePublicSite } from '../../i18n/publicSiteText';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const { i18n } = useTranslation();
  const language = i18n.resolvedLanguage || i18n.language;
  const text = (english: string) => translatePublicSite(language, english);

  return (
    <Box component="footer" sx={{ bgcolor: 'primary.dark', color: 'white', py: 3, mt: 'auto' }}>
      <Container maxWidth="lg">
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} justifyContent="space-between" alignItems={{ md: 'center' }}>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 600, color: 'secondary.main' }}>
              Kundlistar Studio
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.82)', maxWidth: 620 }}>
              {text('Personal astrology workspace for charts, clients, planner, notes, and reports.')}
            </Typography>
          </Box>
          <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
            <Link component={RouterLink} to="/studio" color="inherit" underline="hover" variant="body2">{text('Studio')}</Link>
            <Link component={RouterLink} to="/studio/pricing" color="inherit" underline="hover" variant="body2">{text('Pricing')}</Link>
            <Link component={RouterLink} to="/blog" color="inherit" underline="hover" variant="body2">{text('Blog')}</Link>
            <Link component={RouterLink} to="/studio/support" color="inherit" underline="hover" variant="body2">{text('Support')}</Link>
            <Link component={RouterLink} to="/privacy-policy" color="inherit" underline="hover" variant="body2">{text('Privacy Policy')}</Link>
            <Link component={RouterLink} to="/terms-and-conditions" color="inherit" underline="hover" variant="body2">{text('Terms & Conditions')}</Link>
          </Stack>
        </Stack>
        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.68)', mt: 2 }}>
          © {currentYear} Kundlistar Studio. {text('All rights reserved.')}
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
